import { Cancel as CancelIcon, CheckOutlined, Print as PrintIcon } from '@mui/icons-material';
import { styled as muiStyled } from '@mui/material/styles';
import Loading from "components/Loading";
import { useMobileDetect } from "hooks/useMobileDetect";
import SuperLessonEditor from "components/ebook/Superlession/LessionEditor";
import { useTabletDetection } from "containers/chat/hooks";
import { filter } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { useAllDistrictTeacher } from "store/users/selectors";
import { useCurrentClass } from "store/classes/selectors";
import { useSentenceStarter } from "store/sentenceStarter/selectors";
import styled from "styled-components";
import color from "utils/constants/color";
import { converMarkToHtml } from "utils/methods/textMethod";
import { find } from "lodash";
import SentenceSvg from "utils/assets/images/Sentence.svg";

import {
  Button as AntdButton,
  Select as AntSelect,
  Skeleton,
  Space,
  Tag,
  Tooltip
} from "antd";

import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import {
  handleCreateSentenceStarter,
  handleDeleteSentenceStarterLesson,
  handleGetSentenceStarter,
  handleUpdateSentenceStarter,
} from "store/sentenceStarter/thunks";
import AIUsageInfo from 'components/Modals/AiInfoModal';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import moment from 'moment-timezone';
import { useShareNotification } from "utils/methods/firebaseShareAssignment";
import useGetRedirectUrlForBook from "containers/hooks/useGetRedirectBook";
import SentryWrap from 'components/Sentry';

// MUI Styled Components
const StyledSelect = muiStyled('div')(({ theme }) => ({
  '& .MuiSelect-select:focus': {
    backgroundColor: 'transparent !important',
  },
  '& .menuItemText': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '150px',
    display: 'block',
  },
  '& .disabledButton': {
    color: 'white',
    '&.Mui-disabled': {
      color: 'white !important',
    },
  }
}));

const ViewerSentenceStarter = ({
  currentUser,
  filterMyData,
  handleUpdateOpenPopUp,
  streamValue, //stream value
  streamEnd
}) => {
  const showAlert = useAlert();
  const imageRef = useRef(null);
  const allDistrictTeacher = useAllDistrictTeacher();
  const [value, setValue] = useState([]);
  const [printLoader, setPrintloader] = useState(false);
  const [loader, setLoader] = useState(false);
  const currentClass = useCurrentClass();
  const sentenceStarterRes = useSentenceStarter();
  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState([]);
  const { Option } = AntSelect;
  const [showShareList, setShowShareList] = useState(true);
  const isTablate = useTabletDetection();
  const {updatePopUpAtOnce} = usePopUpAtOnce();
  const isMobile = useMobileDetect() && !isTablate;
  const { createShareNotification } = useShareNotification();
  const { redirectToBook } = useGetRedirectUrlForBook();

  const updatedFilterMyData = useMemo(() => {
    if (!filterMyData?.id) return filterMyData;
    
    if (sentenceStarterRes && Array.isArray(sentenceStarterRes) && sentenceStarterRes.length > 0) {
      const updatedData = find(sentenceStarterRes, (item) => item?.id === filterMyData.id);
      if (updatedData) {
        return updatedData;
      }
    }
    return filterMyData;
  }, [filterMyData, sentenceStarterRes]);

  const renderedContent = useMemo(() => {
    const streamContent = streamValue?.value || "";
    const updatedContent = updatedFilterMyData?.starter_content || "";
    const hasUpdatedContent = updatedContent.trim() !== "";
    const hasStreamContent = streamContent.trim() !== "";

    const content =
    hasStreamContent ? streamContent : hasUpdatedContent ? updatedContent : "";

    return converMarkToHtml(content) ?? "";
  }, [streamValue, updatedFilterMyData?.starter_content, streamEnd]);

  const filterByTeacher = allDistrictTeacher.find(
    (item) => updatedFilterMyData?.userId === item.id
  );

  useEffect(() => {
    const initialAccessBy =
      updatedFilterMyData?.access_by?.filter(
        (element) => element !== updatedFilterMyData?.userId
      ) || [];
    setInitialValues(initialAccessBy);
  }, [updatedFilterMyData]);

  const sharedProps = {
    mode: "multiple",
    style: {
      width: "100%",
    },
    placeholder: "Select Item...",
    maxTagCount: "responsive",
    showSearch: true,
    optionFilterProp: "label",
    filterOption: (input, option) => {
      const label = (option?.label || option?.children || '').toString().trim().toLowerCase();
      const searchText = input.trim().toLowerCase();
      if (!searchText) return true;
      const searchWords = searchText.split(/\s+/).filter(word => word.length > 0);
      return searchWords.every(word => label.includes(word));
    },
  };

  const validationPrint = () => {
    if (isMobile || isTablate) {
      showAlert("Print is not supported on this device!", "error");
      return;
    } else {
      printCall();
    }
  };

  const printCall = useReactToPrint({
    contentRef: imageRef,
    onBeforeGetContent: async () => {
      setPrintloader(true);
    },
    onBeforePrint: async () => {
      setPrintloader(false);
    },
  });

  const getAllOptions = useMemo(() => {
    return allDistrictTeacher.map((item) => ({
      label: `${item.firstName} ${item.lastName},`,
      value: `${item?.id}`,
    }));
  }, [allDistrictTeacher]);

  const selectProps = {
    value,
    onChange: (selectedIds) => {
      const newSelections = selectedIds.filter(
        (item) => !initialValues.includes(item.value)
      );

      const updatedSelection = [
        ...value.filter((item) => initialValues.includes(item.value)),
        ...newSelections,
      ];

      setValue(updatedSelection);
    },
    labelInValue: true,
  };

  const handleShareDelete = async () => {
    try {
      const data = {
        ...updatedFilterMyData,
        access_by: filter(
          updatedFilterMyData?.access_by,
          (access) => access !== currentUser?.id
        ),
      };
      if (data?.access_by?.length === 0) {
        setLoader(true);
        await dispatch(handleDeleteSentenceStarterLesson(data?.id));
        setLoader(false);
        showAlert("Deleted Successfully", "success");
      } else {
        setLoader(true);
        await dispatch(handleCreateSentenceStarter(data));
        setLoader(false);
      }
      setValue([]);
      setShowShareList(true);
      handleUpdateOpenPopUp(
        { open: true, type: "sentenceStarterOption" },
        "set"
      );
      // setFilterSharedLesson(filterShareLesson);
      // setFilterMyData(filterLesson);
      // onClose();
    } catch (error) {
      console.log(error);
    }
  };


  const isDisable = () => {
    const selectedTeacher = value?.map((element) => element?.value);
    const combinedArray = [...selectedTeacher];
    combinedArray.push(updatedFilterMyData?.userId);
    const shareableArr = filter(
      combinedArray,
      (val) => val !== currentUser?.id
    );
    return shareableArr.length == 0 ? false : true;
  };

  const handleShare = async () => {
    try {
      setLoader(true);
      const selectedTeacher = value?.map((element) => element?.value);
      const combinedArray = [...new Set([...selectedTeacher, ...initialValues])];
      combinedArray.push(updatedFilterMyData?.userId);
      const shareableArr = filter(
        combinedArray,
        (val) => val !== currentUser?.id
      );
      if (shareableArr?.length === 0) return;
      const newlySharedTeachers = selectedTeacher.filter(
        (teacherId) => !initialValues.includes(teacherId)
      );
      
      const data = {
        ...updatedFilterMyData,
        access_by: combinedArray,
        shared_time: moment().toISOString()
      };
      const result = await dispatch(handleCreateSentenceStarter(data));
      if (result && newlySharedTeachers.length > 0) {
        const url = redirectToBook({
          chapter: updatedFilterMyData?.bookId,
          page: updatedFilterMyData?.pageId
        });
        
        const notificationData = {
          id: result?.id || updatedFilterMyData?.id,
          notification_list: newlySharedTeachers,
          createdBy: currentUser.id,
          checkBookExist: true,
          bookId: updatedFilterMyData?.bookId,
          pageId: updatedFilterMyData?.pageId,
          chapter: updatedFilterMyData?.bookId,
          page: updatedFilterMyData?.pageId,
          displayName: 'Sentence Starter',
          data: {
            chapter: updatedFilterMyData?.bookId,
            page: updatedFilterMyData?.pageId,
            id: result?.id || updatedFilterMyData?.id,
            assignmentType: 'sentence_starter'
          },
          message: `${currentUser?.firstName} ${currentUser?.lastName} shared a Sentence Starter`,
          shared_time: moment().toISOString(),
          url: url || `/ebook?chapter=${updatedFilterMyData?.bookId}&page=${updatedFilterMyData?.pageId}&activity=null&quiz=null`,
        };
        
        const shareId = updatedFilterMyData?.userId || currentUser.id;
        await createShareNotification(notificationData, shareId);
      }
      
      showAlert("Shared Successfully", "success");
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;

    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    const isInitiallySelected = initialValues.includes(value);
    return (
      <Tag
        color={"blue"}
        onMouseDown={onPreventMouseDown}
        closable={!isInitiallySelected && closable}
        onClose={onClose}
        style={{ marginInlineEnd: 4 }}
      >
        {label?.length > 10 ? label.slice(0, 10) : label}
      </Tag>
    );
  };

  return (
    <SentryWrap>
      <LessonContainer>
        <LessonModal>

        <div className='viewerSentenceInfo'>
        <div style={{ marginRight: '5px' }}>
          <AIUsageInfo />
        </div>
        <span
          onClick={() => {
            handleUpdateOpenPopUp({}, "set");
            updatePopUpAtOnce(false);
          }}
        >
          <CancelIcon
            style={{
              float: "right",
              fontSize: 20,
              color: "red",
              background: "white",
              borderRadius: 20,
              cursor: "pointer",
              marginBottom: 2,
            }}
          />
        </span>
        </div>
        
        {currentUser?.role === "teacher" && (
          <Container>
            {streamEnd ? (
              <div className='cstmSkeleton sentenceStartSkeleton'><Skeleton active paragraph={{ rows: 2 }} title={false} /></div>
            ) : (
            <div className="overflowAuto marginBottom10" >
              {updatedFilterMyData?.userId === currentUser?.id ? (
                <>
                <div className="mainDifferentiationLession sentenceStartersCstm">
                  <img src={SentenceSvg} alt="" title="" />
                  <div className="differentiationLessionHead">
                    <span>Sentence Starters</span>
                  </div>
                </div>

                <BoxContainer className='sentenceStartersCstmBox'>
                  <Label>Share With:</Label>
                  <FieldShareBox
                    style={{
                      background: "none",
                      flex: "1",
                      border: "none",
                      placeItems: "start",
                    }}
                  >
                    <Space
                      direction="vertical"
                      style={{ width: "150px", maxWidth: "149px" }}
                    >
                      <StyledSelect>
                      <AntSelect
                        dropdownStyle={{ minWidth: "250px" }}
                        tagRender={tagRender}
                        className="dropdown-select"
                        {...sharedProps}
                        {...selectProps}
                        menuItemSelectedIcon={null}
                        maxTagPlaceholder={(omittedValues) => (
                          <Tooltip
                            overlayStyle={{
                              pointerEvents: "none",
                            }}
                            title={omittedValues.map(({ label }) => label)}
                          >
                            <span>...more</span>
                          </Tooltip>
                        )}
                      >
                        {getAllOptions.map((item) => {
                          const cleanLabel = item.label.replace(/,\s*$/, '');
                          return (<Option key={item.value} value={item.value} label={cleanLabel}>
                            {initialValues.includes(item?.value) ? (
                              <span className="shared-text-super-lesson">
                                Shared
                              </span>
                            ) : (
                              <>
                                {value.some(
                                  (data) => data.value === item?.value
                                ) && (
                                  <CheckOutlined className="checkmark-icon-super-lesson" />
                                )}
                              </>
                            )}
                            <Space>
                              {cleanLabel.length > 19
                                ? cleanLabel?.slice(0, 19) + "..."
                                : cleanLabel}
                            </Space>
                          </Option>
                          );
                        })}
                      </AntSelect>
                    </StyledSelect>
                  </Space>
                </FieldShareBox>

                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (isDisable()) {
                        handleShare();
                      }
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <AntdButton
                        className="share-button-super-lesson"
                        type="primary"
                        loading={loader}
                        disabled={!isDisable()}
                        style={{
                          borderRadius: 10,
                          border: "0px",
                          color: "black",
                          cursor: isDisable() ? "pointer" : "not-allowed",
                          backgroundColor: isDisable() ? undefined : "#b3b3b3",
                        }}
                      >
                        Share
                      </AntdButton>
                    </span>
                  </div>
                  <div
                    style={{ cursor: "pointer", width: "50px" }}
                    onClick={() => {
                      validationPrint();
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <AntdButton
                        className="share-button-super-lesson"
                        type="primary"
                        style={{
                          borderRadius: 10,
                          border: "0px",
                          color: "black",
                        }}
                      >
                        {printLoader ? <Loading size={20} /> : <PrintIcon />}
                      </AntdButton>
                    </span>
                  </div>
                  <BoxContainer className="flex-1">
                    <SuperLessonEditor
                      initialMarkdown={updatedFilterMyData?.starter_content || ""}
                      onSave={async (content) => {
                        const updateResult = await dispatch(
                          handleUpdateSentenceStarter(updatedFilterMyData?.id, content)
                        );
                        
                        if (updateResult && updateResult.success) {
                          setTimeout(async () => {
                            await dispatch(
                              handleGetSentenceStarter({
                                bookId: updatedFilterMyData?.bookId,
                                pageId: updatedFilterMyData?.pageId,
                                userId: currentUser?.id,
                                role: currentUser?.role,
                                class_id: currentClass?.id,
                              })
                            );
                          }, 200);
                        }
                      }}
                      id={updatedFilterMyData?.id}
                      isDifferentaition={true}
                      from={"sentence_starter"}
                    />
                  </BoxContainer>
                </BoxContainer>
                </>
              ) : streamValue?.value ? (
                <div className='sentenceStartSkeleton'><Skeleton active paragraph={{ rows: 2 }} title={false} /></div>
              ) : (
                <BoxContainer
                  style={{
                    marginRight: 6,
                    // marginLeft: 108,
                    marginBottom: 15,
                  }}
                >
                  <Label>Share By:</Label>
                  <FieldShareBox>
                    {`${filterByTeacher?.firstName} ${filterByTeacher?.lastName}`}
                  </FieldShareBox>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleShareDelete();
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <AntdButton
                        type="primary"
                        loading={loader}
                        style={{
                          borderRadius: 10,
                          minWidth: 108,
                          backgroundColor: color.greentrue,
                          border: "0px",
                        }}
                      >
                        {"Delete"}
                      </AntdButton>
                    </span>
                  </div>
                  <div
                    style={{ cursor: "pointer", width: "50px" }}
                    onClick={() => {
                      validationPrint();
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <AntdButton
                        className="share-button-super-lesson"
                        type="primary"
                        style={{
                          borderRadius: 10,
                          border: "0px",
                          color: "black",
                        }}
                      >
                        {printLoader ? <Loading size={20} /> : <PrintIcon />}
                      </AntdButton>
                    </span>
                  </div>
                </BoxContainer>
              )}
            </div>
            )}
          </Container>
        )}
        <WhiteBox ref={imageRef} className="printable">
          <div
            style={{ maxHeight: "unset", padding: 0 }}
            className="lesson-plan-container printable"
            dangerouslySetInnerHTML={{
              __html: renderedContent ?? "",
            }}
          />
        </WhiteBox>
      </LessonModal>
    </LessonContainer>
    </SentryWrap>
  );
};

export default ViewerSentenceStarter;

const LessonContainer = styled.section`
  padding-top: 15px;
  padding-left: 27px;
  padding-right: 33px;
  padding-bottom: 20px;
  background: transparent;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 50;
  @media (max-width: 700px) {
    display: ${(p) => (p.isCanvasUser ? "unset" : "none")};
  }
`;

const LessonModal = styled.div`
  background: #000f4c;
  border-radius: 11px;
  padding-left: ${(p) => (p.view ? "51px" : "19px")};
  padding-right: ${(p) => (p.view ? "51px" : "19px")};
  padding-bottom: ${(p) => (p.view ? "34px" : "26px")};
  padding-top: ${(p) => (p.view ? "51px" : "10px")};
  height: ${(p) => (p.view ? "unset" : "95%")};
  // overflow: hidden auto;
  display: flex;
  flex-direction: column;
  @media (max-width: 820px) {
    height: 90%;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
`;

const SuperLessonLogoImg = styled.img`
  @media (max-width: 768px) {
    width: 57px;
    height: 51px;
  }
`;

const BoxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Label = styled.label`
  color: #fff;
  // font-family: "Gotham";
  font-size: 15px;
  font-style: italic;
  font-weight: 400;
  // font-family: Gotham;
  white-space: nowrap;

  @media (max-width: 768px) {
    color: #fff;
    font-size: 13px;
    font-style: italic;
    font-weight: 400;
  }
`;

const FieldShareBox = styled.div`
  display: grid;
  place-items: center;
  border-radius: 9.5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  text-align: center;
  // min-width: 63px;

  // width: 108px;
  // height: 31px;
  color: #000;
  // font-family: Gotham;
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  flex: 1;
  max-width: 241px;
  padding:1px;

  @media (max-width: 768px) {
    color: #000;
    // font-family: "Gotham";
    font-size: 10px;
    font-style: italic;
    font-weight: 400;
  }
`;

const WhiteBox = styled.div`
  height: 100%;
  padding: 4px 10px 10px 10px;
  border-radius: 10px;
  border: 2px solid #e8e8e8;
  background: #fff;
  width: 100%;
  // height: 100%;
  // max-height: 700px;

  margin-top: 0px;
  overflow-x: hidden;
  background-color: #fff;
  overflow-y: auto;

  // @media (max-width: 1367px) {
  //   height: calc(100% - 195px);
  // }

  // @media (max-width: 768px) {
  //   height: calc(100% - 188px);
  // }
  @media print {
    position: relative;
    width: auto;
    height: auto;
    overflow: visible;
    display: block;

    &,
    & * {
      page-break-inside: avoid;
    }

    .lesson-plan-container {
      page-break-after: avoid;
    }
  }
`;